<template>
    <router-view></router-view>
</template>
<script>
export default {
    
}
</script>
<style>
    .card {
        min-height: inherit !important;
    }
</style>